import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";

export default function S911TopMenu({ slug, activeMenu }) {
  const [studentInfo, setStudentInfo] = useState(0);

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info[0].class);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
 <div className="breadcrumb-bar breadcrumb-bar-info mb-2 sticky-top">
      <div className="container-fluid text-center">
        <div className="d-flex justify-content-between flex-wrap">
          <div>
            <h6>Planning Room</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
              <div>
                  <Link
                    to={`/student911/student-tasklist`}
                    className={
                      activeMenu === "Agenda"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Agenda
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/student911/student-schedulelist`}
                    className={
                      activeMenu === "CollegeVisit"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Schedule
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/student911/student-personal-questions`}
                    className={
                      activeMenu === "PersonalQuestions"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Career
                  </Link>
                </div>
                {/*}
                  <div>
                  <Link
                    to={`/student911/student-task`}
                    className={
                      activeMenu === "Task"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Task
                  </Link>
                </div>
                {*/}
              </div>
            </div>
          </div>
          <div>
            <h6>Academics</h6>
            <div className="row">
              <div className="d-flex justify-content-between">
              <div>
                  <Link
                    to={`/student911/student-gradeinmonth`}
                    className={
                      activeMenu === "GradeList"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Grades
                  </Link>
                </div>
                <div>
                <Link
                    to={`/student911/student-lessons`}
                    className={
                      activeMenu === "Lessons"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Courses
                  </Link>
                  </div>
              <div>
                <Link
                  to={`/student911/student-goal-questions`}
                  className={
                    activeMenu === "GoalGrades"
                      ? "tag text-decoration-underline text-info"
                      : "tag"
                  }
                >
                  SAT
                </Link>
              </div>

{/*}
                <div>
                  <Link
                    to={`/student911/student-transkript`}
                    className={
                      activeMenu === "Transkript"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Transcript
                  </Link>
                </div>
*/}
                <div>
                  <Link
                    to={`/student911/student-booklist`}
                    className={
                      activeMenu === "BookList"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Readings
                  </Link>
                </div>

                {/* <div>
                <Link
                    to={`/student911/student-coursesreport`}
                    className={
                      activeMenu === "CoursesReport"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Courses Report
                  </Link>
                  </div> */}
              </div>
            </div>
          </div>

          <div>
            <h6>Activities & Awards</h6>
            <div className="row">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/student911/student-activitiesandreports`}
                    className={
                      activeMenu === "Activity"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Activities
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/student911/student-awards`}
                    className={
                      activeMenu === "Awards"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Awards
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6> {`#`} </h6>
            <div className="row">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/student911/student-resource`}
                    className={
                      activeMenu === "Resources"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    Resources
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/student911/student-collegeprofile`}
                    className={
                      activeMenu === "Profile"
                        ? "tag text-decoration-underline text-info"
                        : "tag"
                    }
                  >
                    College Profile
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
